import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["background", "blockSize", "inlineSize"];
import styled from 'styled-components';
import { LayoutTile } from 'breeze-intelligence-kit';
// @ts-expect-error bender-url not typed
import src from 'bender-url!../../../images/data-agent-illustration.svg';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const CoverImage = styled.img.withConfig({
  displayName: "DataAgentIllustration__CoverImage",
  componentId: "jmq1ih-0"
})(["--offset:0.625rem;--image-size:calc(100% + var(--offset));object-fit:cover;object-position:center;block-size:var(--image-size);inline-size:var(--image-size);position:relative;inset:-0.25rem;max-inline-size:", ";"], ({
  maxInlineSize
}) => maxInlineSize);
export const DataAgentIllustration = _ref => {
  let {
      background = 'background-color-light',
      blockSize = '8.375rem',
      inlineSize = '100%'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutTile, Object.assign({}, rest, {
    background: background,
    blockSize: blockSize,
    inlineSize: inlineSize,
    overflow: "hidden",
    padding: "0",
    children: /*#__PURE__*/_jsx(CoverImage, {
      alt: I18n.text('dataAgentPanel.title'),
      src: src
    })
  }));
};